const config = ({
    // eslint-disable-next-line no-undef
    apiUrl: process.env.REACT_APP_API_URL || "http://localhost:4000/api"
})
export default config